import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { SalesOrderHeaderDeliveryItem } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderDeliveryItemService extends TmsWebBaseEditCreateService<
  SalesOrderHeaderDeliveryItem,
  SalesOrderHeaderDeliveryItem
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('SalesOrderDeliveryItem', $localize`Sales Order Delivery Item`);
  }

  getForSalesOrderHeader(id: string): Observable<SalesOrderHeaderDeliveryItem[]> {
    return this.httpService.get<SalesOrderHeaderDeliveryItem[]>(`${this.apiUrl}/SalesOrderHeader?id=${id}`);
  }

  // Ensure a delivery item exists for the header's chosen delivery product (creates one if
  // absent) and set it as the header's primary. Used by the SO header Delivery Product dropdown.
  // chargeDelivery is the tick as it stands on screen; the API prices a new line at 0 when it is off.
  ensureDeliveryItem(
    salesOrderHeaderId: string,
    deliveryProductId: string,
    chargeDelivery?: boolean,
  ): Observable<void> {
    return this.httpService.post(`${this.apiUrl}/EnsureDeliveryItem`, {
      salesOrderHeaderId,
      deliveryProductId,
      chargeDelivery,
    });
  }
}
